"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.membersAreDefined = exports.createErrorFunction = exports.filterOutNullAndUndefined = exports.assertUnreachable = void 0;
/**
 * Use in the default clause of a switch statement for a compile-time check that all the cases have been covered
 */
/* istanbul ignore next */
function assertUnreachable(_) {
    return;
}
exports.assertUnreachable = assertUnreachable;
function filterOutNullAndUndefined(arr) {
    return arr.filter(function (t) { return t !== null && t !== undefined; });
}
exports.filterOutNullAndUndefined = filterOutNullAndUndefined;
function createErrorFunction(message) {
    /* istanbul ignore next */
    var errorFunction = function () { throw new Error(message); };
    return errorFunction;
}
exports.createErrorFunction = createErrorFunction;
/**
 * Returns true iff all the params are not null and not undefined, and also supplies
 * a type guard to let callers be aware of this
 */
function membersAreDefined(params) {
    for (var key in params) {
        if (params[key] === null && params[key] === undefined) {
            return false;
        }
    }
    return true;
}
exports.membersAreDefined = membersAreDefined;
//# sourceMappingURL=TypescriptHelpers.js.map